<template>
  <div>
    <el-form label-position="left" label-width="130px">
      <el-form-item label="主题色">
        <div class="box">
          <div class="choose-item" v-if="info.main_color==1||info.main_color==null">
            <div class="color"></div>
            <span class="color-text">经典</span>
          </div>
          <div class="choose-item" v-if="info.main_color==2">
            <div class="color orange"></div>
            <span class="color-text">活力橙</span>
          </div>
          <div class="choose-item" v-if="info.main_color==3">
            <div class="color violet"></div>
            <span class="color-text">热情紫</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="样式">
        <div class="type-box" v-if="info.main_theme===1||info.main_theme==null">
          <div class="img-box"  >
            <img :src="type_classic" alt />
          </div>
          <span>经典</span>
        </div>
        <div class="type-box" v-else>
          <div class="img-box"  >
            <img :src="type_card" alt />
          </div>
          <span>卡片式</span>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import type_card from '@imgs/type_card.png';
import type_classic from '@imgs/type_classic.png';

export default {
  props:{
    info:Object,
  },
  data: () => ({
    type_card,
    type_classic,
    colorType: 1,
    styleType: 1,
  }),
  methods: {
    chooseColor(idx) {
      this.colorType = idx;
    },
    chooseStyle(idx) {
      this.styleType = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: row;
  width: 96px;
  .choose-item {
    text-align: center;
    flex: 1;
    margin: 0 16px;
    margin-left: 0px;
    .color {
      height: 40px;
      border-radius: 6px;
      background: #ff6765;
      text-align: center;
      .svg-icon {
        width: 24px;
        height: 24px;
        vertical-align: -12px;
      }
    }
    .orange {
      background: #ff9c00;
    }
    .violet {
      background: #8c41df;
    }
  }
}
.type-box {
  display: inline-block;
  text-align: center;
  .img-box {
    position: relative;
    width: 109px;
    height: 234px;
    box-sizing: content-box;
    border-radius: 15px;
    padding: 5px;
    background: #8d9299;
    .icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .svg-icon {
        width: 24px;
        height: 24px;
      }
    }
    img {
      width: 109px;
      height: 234px;
    }
  }
  .img-box-active {
    background: $theme;
  }
}
/deep/ .el-form-item__label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(35, 37, 38, 1);
}
/deep/ .el-form-item__content {
  .color-text {
    line-height: 20px;
  }
  .choose-item {
    line-height: 30px;
  }
}
</style>